import { render, staticRenderFns } from "./FrFormNoInput.vue?vue&type=template&id=079336fa&"
import script from "./FrFormNoInput.vue?vue&type=script&lang=js&"
export * from "./FrFormNoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports